import { ExternalLink, AlertTriangle, ShieldCheck } from "lucide-react";

const BROKER_URL = "https://fusionmarkets.com/?refcode=82240";

const stats = [
  { label: "Spreads dès", value: "0,0", sub: "pips en compte Zero", color: "text-blue-400" },
  { label: "Commission", value: "4,50 $", sub: "par lot aller-retour", color: "text-green-400" },
  { label: "Dépôt min.", value: "0 $", sub: "Aucun minimum requis", color: "text-purple-400" }
];

const benefits = [
  { title: "✓ Frais Ultra Bas", text: "Parmi les commissions les plus basses du marché" },
  { title: "✓ Plateformes au Choix", text: "MetaTrader 4, MetaTrader 5, cTrader et TradingView" },
  { title: "✓ Dépôts & Retraits Simples", text: "Plusieurs moyens de paiement pour déposer et retirer facilement" },
  { title: "✓ Broker Régulé", text: "Régulé par l'ASIC (Australie), la VFSC (Vanuatu) et la FSA (Seychelles)" }
];

export const BrokerSection = () => (
  <div className="fade-in" data-testid="broker-section">
    <div className="text-center mb-12">
      <h2 className="text-4xl sm:text-6xl font-bold mb-6" data-testid="broker-title">Broker Partenaire</h2>
      <p className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto">
        Tradez avec le broker #1 : régulé, spreads serrés et frais parmi les plus bas du marché
      </p>
    </div>

    <div className="max-w-4xl mx-auto">
      <div className="relative p-12 rounded-2xl bg-white/5 border-2 border-white/10 backdrop-blur-sm">
        <div className="text-center mb-8 pt-6 sm:pt-0">
          <img src="/logos/fusion-markets.svg" alt="Logo Fusion Markets" className="absolute top-5 left-5 h-9 w-auto" data-testid="broker-logo" />
          <div className="flex flex-wrap items-center justify-center gap-3 mb-4">
            <h3 className="text-3xl font-bold" data-testid="broker-name">Fusion Markets</h3>
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-green-500/15 border border-green-500/40 text-green-400 text-sm font-semibold" data-testid="broker-regulated-badge">
              <ShieldCheck size={16} />
              Régulé ASIC
            </span>
          </div>
          <p className="text-white/70 leading-relaxed">
            Ouvrez votre compte chez Fusion Markets et profitez de conditions de trading pensées pour les traders actifs : spreads bruts, commissions réduites et aucun dépôt minimum.
          </p>
        </div>

        <div className="mb-8 p-6 rounded-xl bg-gradient-to-r from-amber-500/20 to-orange-500/20 border-2 border-amber-400/40" data-testid="broker-warning">
          <div className="flex items-center justify-center gap-3 mb-3">
            <AlertTriangle size={30} className="text-amber-400" />
            <h4 className="text-2xl font-bold text-amber-400">Avertissement Important</h4>
          </div>
          <p className="text-center text-xl font-bold mb-3">
            <span className="text-amber-300">Pas encore rentable ? N'ouvrez JAMAIS de compte réel.</span>
          </p>
          <div className="bg-black/30 p-4 rounded-lg border border-amber-400/30">
            <p className="text-center text-base text-white/90 leading-relaxed">
              Trader en réel sans être rentable, c'est la garantie de tout perdre. Avant même d'y penser, vous devez prouver votre rentabilité sur <span className="font-bold text-amber-300">plusieurs mois</span>, voire <span className="font-bold text-amber-300">plusieurs quarters</span> consécutifs. Seulement à ce moment-là, vous pourrez envisager d'ouvrir un compte réel.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-3 gap-6 mb-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center p-6 rounded-xl bg-white/5">
              <h4 className="text-2xl font-bold mb-2">{s.label}</h4>
              <p className={`text-3xl font-bold ${s.color}`}>{s.value}</p>
              <p className="text-sm text-white/60 mt-2">{s.sub}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href={BROKER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-black font-bold text-lg rounded-lg hover:bg-white/90 hover:scale-105 transition-all shadow-xl"
            data-testid="broker-cta-button"
          >
            Ouvrir un compte Fusion Markets
            <ExternalLink size={22} />
          </a>
          <p className="mt-4 text-sm text-white/50">Lien partenaire 700S ICT</p>
        </div>
      </div>

      <div className="mt-12 grid md:grid-cols-2 gap-6">
        {benefits.map((b) => (
          <div key={b.title} className="p-6 rounded-xl bg-white/5 border border-white/10">
            <h4 className="font-bold text-lg mb-3">{b.title}</h4>
            <p className="text-white/70 text-sm">{b.text}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);
